"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shiftTZLocalToX = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const MINUTE_MILLIS = 60 * 1000;
function shiftTZLocalToX(localDate, timezone) {
    const isDate = localDate instanceof Date;
    const localOffset = (0, moment_timezone_1.default)(localDate).utcOffset();
    const utcDate = new Date();
    utcDate.setTime((0, moment_timezone_1.default)(localDate).valueOf() + localOffset * MINUTE_MILLIS);
    const tzOffset = moment_timezone_1.default.tz(localDate, timezone).utcOffset();
    const tzDate = new Date();
    tzDate.setTime(utcDate.getTime() - tzOffset * MINUTE_MILLIS);
    return (isDate ? tzDate : (0, moment_timezone_1.default)(tzDate));
}
exports.shiftTZLocalToX = shiftTZLocalToX;
exports.default = shiftTZLocalToX;
